// Live Pool totals arrive as text, such as "R1,234,567.00".

// Drops each "R" and the first ".00" after it, as poolTotal.replace(/R(.*?)\.00/g, "$1")
// did for text without line breaks, without that regex's backtracking.
const stripRandAndCents = (text) => {
  let stripped = "";
  let from = 0;
  for (let r = text.indexOf("R"); r !== -1; r = text.indexOf("R", from)) {
    const cents = text.indexOf(".00", r + 1);
    if (cents === -1) break;
    stripped += text.slice(from, r) + text.slice(r + 1, cents);
    from = cents + 3;
  }
  return stripped + text.slice(from);
};

// The total in whole rands. A total with cents other than ".00" is NaN.
export const parsePoolTotal = (poolTotal) => parseInt(stripRandAndCents(poolTotal).replace(/,/g, ""));

// Largest pool first, for Array.prototype.sort.
export const byPoolTotalDescending = (a, b) => (parsePoolTotal(a.poolTotal) < parsePoolTotal(b.poolTotal) ? 1 : -1);
